import React from 'react'
import { themeKey } from '~/common/theme-key'

export const BORDER_RADIUS = 4

export const COLORS2 = {
  ash: {
    500: '#333333' as const,
  },
  beige: {
    // 900: '#655F55' as '#655F55,
    // 800: '#8B8275' as '#8B8275,
    // 700: '#B1A694' as '#B1A694,
    600: '#EEDFC7' as const,
    500: '#FDEDD4' as const,
    // 400: '#FDF0DA' as '#FDF0DA',
    // 300: '#FEF2E1' as '#FEF2E1',
    // 200: '#FEF5E7' as '#FEF5E7',
    // 100: '#FEF8EE' as '#FEF8EE',
    // 50: '#FFFBF4' as '#FFFBF4',
  },
  blue: {
    // 900: '#263864' as '#263864',
    // 800: '#344C8A' as '#344C8A',
    // 700: '#4361AF' as '#4361AF',
    // 600: '#5176D5' as '#5176D5',
    500: '#5F8BFA' as const,
    // 400: '#779CFB' as '#779CFB',
    300: '#99B6FF' as const,
    // 200: '#A7BFFC' as '#A7BFFC',
    100: '#BFD1FD' as const,
    // 50: '#D7E2FE' as '#D7E2FE',
    10: '#EEF2FF' as const,
  },
  lightBlue: {
    // 900: '#254F5D' as '#254F5D',
    // 800: '#336D80' as '#336D80',
    // 700: '#418BA3' as '#418BA3',
    600: '#4FA8C6' as const,
    500: '#5DC6E9' as const,
    // 400: '#75CFEC' as '#75CFEC',
    // 300: '#8ED7F0' as '#8ED7F0',
    // 200: '#A6E0F3' as '#A6E0F3',
    // 100: '#BEE8F6' as '#BEE8F6',
    50: '#D7F1FA' as const,
    10: '#EFF9FD' as const,
  },
  red: '#F1106B' as const,
  purple: '#8C72CB' as const,
  green: '#A6D960' as const,
  yellow: '#FCD872' as const,
  orange: {
    400: '#FFB65C' as const,
    500: '#FFA02D' as const,
  },
  gray: {
    1200: '#121212' as const,
    1100: '#FBFBFB' as const,
    1000: '#EBEBEB' as const,
    900: '#2F2F2F' as const,
    800: '#404040' as const,
    700: '#525252' as const,
    600: '#636363' as const,
    500: '#757575' as const,
    450: '#8F8F8F' as const,
    400: '#8A8A8A' as const,
    350: '#474747' as const,
    300: '#9E9E9E' as const,
    200: '#B3B3B3' as const,
    100: '#C8C8C8' as const,
    50: '#DDDDDD' as const,
    40: '#FAFAFA' as const,
    30: '#e0e0e0' as const,
    20: '#f5f5f9' as const,
    10: '#F1F1F1' as const,
  },
  white: '#FFF' as const,
  black: '#000000' as const,
  pink: '#EF086C' as const,
}

export const COLORS = {
  blue: COLORS2.blue[500],
  lightBlue: COLORS2.lightBlue[500],
  secondLightBlue: '#97b6f9' as const,
  transparentBlue: 'rgba(94, 139, 250, .25)',
  bubbleBlue: '#ebf1ff' as const,
  darkBlue: '#2e5cc5' as const,
  red: '#F1106B' as const,
  lightRed: '#FF5F69' as const,
  watermelon: '#EF9A91' as const,
  purple: '#8C72CB' as const,
  darkGreen: '#3FC293' as const,
  mediumGreen: '#00C896' as const,
  mint: '#7FD0B0' as const,
  green: '#A6D960' as const,
  yellow: '#FCD872' as const,
  yellow2: '#FFCC77' as const,
  yellowWarning: '#FFB65C' as const,
  orange: '#FF9600' as const,
  beige: COLORS2.beige[500],
  darkBeige: COLORS2.beige[600],
  lightestGray: COLORS2.gray[10],
  lighterGray: COLORS2.gray[50],
  lightGray: COLORS2.gray[100],
  lighterMediumGray: COLORS2.gray[400],
  mediumGray: COLORS2.gray[500],
  darkGray: COLORS2.gray[800],
  darkerGray: COLORS2.gray[1200],
  gray2: '#e9ebee' as const,
  gray3: '#e3e7f1' as const,
  gray4: '#E8E8E8' as '#e8e8e8',
  grey4: '#f5f5f5' as const, //According to Hydrogen, this should be grey4
  gray5: '#5c5c5c' as const,
  gray6: '#858585' as const,
  gray350: COLORS2.gray[350],
  gray450: COLORS2.gray[450],
  white: '#fff' as const,
  offWhite: '#fafafa' as const,
  background: '#F6F7F9' as const,
  mediumBlue: '#6491FF' as const,
  black: '#000' as const,
  currentColor: 'currentColor' as const,
  iconGrey: '#B6B6B6' as const,
}

export const CAPACITY_BOX_COLORS = {
  lightBlue: '#EBF1FF' as const,
  activeBlue: '#99B6FF' as const,
  mediumBlue: '#6491FF' as const,
  lightGreen: '#EBFFFA' as const,
  activeGreen: '#78EDBC' as const,
  mediumGreen: '#00C896' as const,
  lightYellow: '#FFFAE8' as const,
  activeYellow: '#FFEB99' as const,
  mediumYellow: '#FFE785' as const,
  lightRed: '#FFE1E3' as const,
  activeRed: '#FF99A0' as const,
  mediumRed: '#FF5F69' as const,
  secondaryText: '#8F8F8F' as const,
}

export const TAG_COLORS = {
  red: '#FA1549' as const,
  orange: '#FF5300' as const,
  tangerine: '#FF9600' as const,
  yellow: '#F4C300' as const,
  atlantis: '#A6D960' as const,
  green: '#1DD761' as const,
  shamrock: '#00C9AA' as const,
  summerSky: '#5DC6E9' as const,
  blue: '#5F8BFA' as const,
  purple: '#8C72CB' as const,
  orchid: '#C340DE' as const,
  rose: '#F1106B' as const,
  mauvelous: '#FC389F' as const,
  pink: '#FF89AD' as const,
  charcoal: '#546B6D' as const,
  gray: '#88A4A7' as const,
}

export const FONT_WEIGHTS = {
  lighter: 300 as const,
  normal: 400 as const,
  semiBold: 600 as const,
  bold: 700 as const,
}

/**
 * For adding more sizes or a reference see:
 * http://www.modularscale.com/?1&em&1.25
 * Using majorThird ratio
 */
export const SIZES = {
  tiny: '4px' as const,
  xxxs: '5px' as const,
  xxs: '6px' as const,
  xs: '8px' as const,
  small: '10px' as const,
  smallMedium: '11px' as const,
  medium: '12px' as const,
  mediumLarge: '13px' as const,
  fourteen: '14px' as const,
  large: '15px' as const,
  sixteen: '16px' as const,
  eighteen: '18px' as const,
  xl: '19px' as const,
  xxl: '23px' as const,
  xxxl: '29px' as const,
  huge: '37px' as const,
  mega: '46px' as const,
  ultra: '54px' as const,
  hyper: '69px' as const,
  sideNavClose: '54px' as const,
  sideNavOpen: '220px' as const,
  mdSideNavOpen: '155px' as const,
  titleSmall: '22px' as const,
  titleLarge: '26px' as const,
}

export const EASING = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
}

/**
 * Timeline View Constants
 */
export const TM_SIZES = {
  firstColumn: '51px',
  firstRow: '54px',
  minCardHeight: '40px',
  column: '35px',
  rowGap: '16px',
  activity: '15px',
  mdSidebar: '120px',
  mdColumnWeek: '65px',
}

export const TM_COLORS = {
  default: themeKey('palette.offBackground.wrapper'),
  today: 'rgba(94, 139, 250, 0.1)',
  offday: `repeating-linear-gradient(
    -45deg,
    #fbfbfc,
    #d2d2d2,
    #fbfbfc 1px,
    #fbfbfc 1px,
    #fbfbfc 4px
  );`,
  projectBg: 'rgba(248, 248, 248, 0.5)',
  Early: {
    alpha: 'rgba(160, 195, 235, 0.1)',
    alphaR: '47',
    alphaG: '122',
    alphaB: '207',
    normal: '#2f7acf',
  },
  Late: {
    alpha: 'rgba(247, 231, 231, 0.3)',
    alphaR: '244',
    alphaG: '67',
    alphaB: '54',
    normal: '#f44336',
  },
  null: {
    alpha: 'white',
    normal: 'white',
  },
}

export const TM_BORDER_RADIUS = 3

/**
 * Context to be used globaly
 **/
interface WhiteLabelingContextValue {
  whiteLabelingEnabled: boolean
  toggleTheme: (newColor: string, whiteLabelingEnabled: boolean) => void
}

export const WhiteLabelingContext =
  React.createContext<WhiteLabelingContextValue | null>(null)

export const EDIT_DRAWER_SIZE = 500
export const EDIT_DRAWER_WITH_MESSAGING = 600
export const EDIT_PROJECT_SIZE = 460

export const TOOLTIP_SIZES = {
  maxWidthTooltip: 270,
  maxHeightTooltip: 40,
}
